// extracted by mini-css-extract-plugin
export default {"card":"common-components-PageLayout-PageLayout__card--g7sIy"};